import { Link } from "react-router-dom";

export const BRAND = "Cem Zebra Ai";

export const Logo = ({ to = "/", size = 34, className = "", sub = false }) => (
  <Link to={to} data-testid="brand-logo" className={`flex items-center gap-2.5 min-w-0 ${className}`}>
    <span className="grid place-items-center rounded-lg bg-white ring-1 ring-black/10 overflow-hidden shrink-0" style={{ width: size, height: size }}>
      <img src="/logo-mark.png" alt={BRAND} className="w-[86%] h-[86%] object-contain" />
    </span>
    <span className="min-w-0 leading-tight brand-text">
      <span className="block text-[15px] font-semibold tracking-tight truncate">Cem Zebra <span className="text-primary">Ai</span></span>
      {sub && <span className="block text-[11px] text-muted-foreground">Google Ads inteligente</span>}
    </span>
  </Link>
);
